export default __webpack_public_path__ + "static/media/checkTeethFalse.98d6bbca.png";